import React from 'react';
import { IReceiptData } from '../../../ApiCalls';
import DateTimeInput from './Forms/DateTimeInput';
import ProgressBar from './Forms/ProgressBar';
import TextInput from './Forms/TextInput';
import CurrencyInput from './Forms/CurrencyInput';
import SelectInput from './Forms/SelectInput';
import { GlobalVariables } from '../../../GlobalVariables';
import VerticalStretch from './Forms/VerticalStretch';
import { ReduxUpdater } from '../../../redux/ReduxUpdater';
import Tooltip from '../tooltiped/Tooltip';
import Toolbubble from '../tooltiped/Toolbubble';
import { useSelector } from 'react-redux';
import Trash from '../icons/Trash';
import { checkReceiptData } from '../Expenses';
import { documentLoadingErrorState, formUpdatingState } from '../../../redux/slices/statusesSlice';
import { NavSpinner } from './Forms/NavSpinner';
import NavButtonsGroup from './Forms/NavButtonsGroup';
import { GlobalConstants } from '../../../GlobalConstants';
import ConfirmAndNextAdminMenu from './AdminMenu';
import TextAreaInput from './Forms/TextAreaInput';
import { FilterCategories } from '../../../Shared';

export interface IConfirmAndNextPettyCashFormProps {
    idx: number;
    max: number;
    receipt: IReceiptData;
    receiptChanges: IReceiptData;
    onConfirm: () => void;
    onSave: () => void;
    onPrev: () => void;
    onNext: () => void;
    onDelete: () => void;
}

const ConfirmAndNextPettyCashForm = (props: IConfirmAndNextPettyCashFormProps) => {
    const currentImageLoadingErrorState = useSelector(documentLoadingErrorState);
    const isFormUpdating = useSelector(formUpdatingState);
    
    const { idx, max, receipt, receiptChanges, onConfirm, onPrev, onNext, onDelete, onSave } = props;

    const [doFilter, setDoFilter] = React.useState(true);

    console.log('ConfirmAndNextPettyCashForm:', receipt, receiptChanges);

    const date = receiptChanges.transaction_date ?? receipt.transaction_date;
    // const TS = Date.now();
    const ID = ''; //`${receipt.id}-${TS}`;
    const mergedData = {
        ...receipt,
        ...receiptChanges,
    };

    const showDialog = () => {
        console.log('ReduxUpdater.currentDialog: deletePetty$');
        GlobalVariables.dialogConfig.textConfirm = 'Delete';
        GlobalVariables.dialogConfig.title = 'Delete Boat Cash receipt';
        GlobalVariables.dialogConfig.content = 'This action will increase your Boat Cash balance and you will not be able to report this receipt as an expense later. Confirm delete?';
        GlobalVariables.dialogConfig.onConfirm = onDelete;
        ReduxUpdater.currentDialog = 'confirmAction';
    };

    const handleConfirm = () => {
        if (checkReceiptData(mergedData, GlobalVariables.coOwnersExtendedArray, currentImageLoadingErrorState)) {
            onConfirm();
        }
    }

    const handleSave = () => {
        setTimeout(() => {
            onSave();
        }, 250);
    }

    const handleRevert = () => {
        ReduxUpdater.receiptChanges = {} as IReceiptData;
    }

    GlobalVariables.allowReceiptChanges = false;
    React.useEffect(() => {
        // console.log('Reset values');
        // ReduxUpdater.receiptChanges = {} as IReceiptData;
        setTimeout(() => {
            GlobalVariables.allowReceiptChanges = true;
        }, 250);
    });

    const showAll = receipt.user_description && receipt.user_description.toLowerCase().indexOf('food') !== -1;
    const filteredCategories = React.useMemo(() => {
        return FilterCategories(receipt, doFilter);
    }, [doFilter, receipt]);

    return (
        <div id={`confirmAndNextPettyCash-${ID}`} className="h-[100%] w-full inline-flex flex-col justify-start items-start gap-4 relative">
            {ConfirmAndNextAdminMenu(receipt)}
            <DateTimeInput
                type={isFormUpdating ? 'locked' : (date === null || date === '' ? 'warning' : 'edit')}
                label="Date / Time"
                receipt={mergedData}
                onUpdate={(newDate) => {
                    if (GlobalVariables.allowReceiptChanges && mergedData.transaction_date !== newDate) {
                        console.log(`transaction_date CHANGES2: |${mergedData.transaction_date}|${newDate}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            transaction_date: newDate,
                            transaction_time: null,
                        };
                    }
                }}
            />
            <TextInput
                idx={`merchant-${ID}`}
                type={isFormUpdating ? 'locked' : (![null, ''].includes(mergedData.vendor_name) ? 'edit' : 'empty')}
                label="Merchant"
                value={mergedData.vendor_name ?? ''}
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && receipt.vendor_name !== newValue) {
                        console.log(`vendor_name CHANGES2: |${receipt.vendor_name}|${newValue}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            vendor_name: newValue,
                        };
                    }
                }}
            />
            <CurrencyInput
                idx={`amount-${ID}`}
                type={isFormUpdating ? 'locked' : (mergedData.amount !== '' && mergedData.currency !== '' && mergedData.currency !== null  ? 'edit' : 'empty')}
                label="Amount"
                amount={mergedData.amount}
                currency={mergedData.currency ?? ''}
                onChange={(amount, currency) => {
                    if (GlobalVariables.allowReceiptChanges && (receipt.amount !== amount || receipt.currency !== currency)) {
                        console.log(`amount CHANGES2: |${receipt.amount}|${amount}|`);
                        console.log(`currency CHANGES2: |${receipt.currency}|${currency}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            amount: amount,
                            currency: currency,
                        };
                    }
                }}
            />
            <div className="self-stretch flex flex-col justify-center gap-2 items-start">
                <div className="sm:inline-flex sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 w-full">
                    <div className="w-[50%] inline-flex self-stretch justify-start text-text-dark text-sm font-normal font-['Inter'] leading-tight">Receipt Status</div>
                    {receipt.receipt_type === 'petty_cash' &&
                        <Toolbubble
                            className="w-full clickable self-stretch"
                            placement="top-end"
                            title="Not Boat Cash?"
                            content={<>If this transaction is incorrectly categorized as Boat Cash and should be matched to a card transaction, the most likely reason is that the Date, Amount, or Currency does not match the receipt.<br /><br />Correct the data manually, then click Save. The status should change to Matched to Transaction.<br /><br /><b>If the problem persists, please email ai@tonylovec.com</b></>}
                            delay={{
                                open: 1000,
                                close: 125
                            }}
                        >
                            <span className="inline-flex self-stretch justify-end text-text-light text-sm font-normal font-['Inter'] leading-tight">Not boat cash?</span>
                        </Toolbubble>
                    }
                </div>
                <div className="sm:inline-flex sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 w-full">
                    <div className="relative self-stretch flex items-center outline-1 border-border-default hover:border-blue-400 rounded-lg bg-white overflow-hidden transition-colors">
                        <div className="py-1.5 sm:py-2 px-4 w-80 bg-bg-input-locked outline-0 inline-flex justify-start items-center gap-2.5 overflow-hidden">{receipt.receipt_type !== 'petty_cash' ? 'Requires MGM attention' : 'Boat Cash'}</div>
                    </div>
                    <Tooltip
                        text="Delete receipt !!!"
                        placement="top-end"
                        textStyling="bg-bg-input-warning text-text-notification outline-0"
                        delay={{
                            open: 250,
                            close: 125,
                        }}
                    >
                        <button
                            onClick={showDialog}
                            className="Icon flex-1 h-10 px-4 bg-bg-input-locked outline-1 border-border-default rounded-lg flex justify-center items-center gap-2.5">
                            <div className="Iconarrows relative">
                                <Trash {...{ height: '24px', width: '24px' }} />
                            </div>
                        </button>
                    </Tooltip>
                </div>
            </div>
            <TextAreaInput
                idx={`userDescription-${ID}`}
                type={isFormUpdating ? 'locked' : 'edit'}
                label="User Description"
                value={mergedData.user_description ?? ''}
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && (receipt.user_description ?? '') !== newValue) {
                        console.log(`user_description CHANGES2: |${receipt.user_description ?? ''}|${newValue}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            user_description: newValue,
                        };
                    }
                }}
            />
            <SelectInput
                idx={`category-${ID}`}
                type={isFormUpdating ? 'locked' : (mergedData.maris_category_id !== null ? 'edit' : 'empty')}
                label="Category"
                value={(mergedData.maris_category_id ?? -1).toString()}
                options={filteredCategories}
                selectClasses=''
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && mergedData.maris_category_id !== parseInt(newValue) && !(mergedData.maris_category_id === null && newValue === '')) {
                        console.log(`maris_category_id CHANGES2: |${mergedData.maris_category_id}|${newValue}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            maris_category_id: parseInt(newValue),
                        };
                    }
                }}
                titleOrAction={showAll && doFilter
                    ? 
                        <button
                            className="text-text-action-button"
                            onClick={() => setDoFilter(false)}
                        >
                            Show all
                        </button> 
                    : ''
                }
            />
            {GlobalVariables.coOwners.length > 1 && <SelectInput
                idx={`coOwner-${ID}`}
                type={isFormUpdating ? 'locked' : 'edit'}
                label="Co-owner Expense Allocation"
                value={mergedData.co_owner_name ?? ''}
                options={GlobalVariables.coOwnersExtendedArray}
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && receipt.co_owner_name !== newValue) {
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            co_owner_name: newValue,
                        };
                    }
                }}
            />}
            <VerticalStretch />
            <ProgressBar value={idx+1} max={max} />
            {
                isFormUpdating
                ? <NavSpinner label="Saving..." />
                : <NavButtonsGroup label={ReduxUpdater.authenticatedUser?.user_role === GlobalConstants.UserRole.ROOT ? 'Confirm & Next' : 'Next'} max={max} onRevert={handleRevert} onSave={handleSave} onPrev={onPrev} onConfirm={ReduxUpdater.authenticatedUser?.user_role === GlobalConstants.UserRole.ROOT ? handleConfirm : onNext} onNext={onNext} />
            }
        </div>
    );
};

export default ConfirmAndNextPettyCashForm;